import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import cjquery from 'jquery';
import language from '../../../assets/languages/language';
import { Tooltip, Col, Row } from 'reactstrap';
import ValidateSaveReportIcon from '../../Common/ValidateSaveReportIcon';
import AppRoutes from '../../config/AppRoutes';
import { renderHTMLContent } from '../../../common/function';
/* eslint-disable*/
class Beginquiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successAlert: false,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      all_question_id: '',
      all_reading_type: '',
      question_length: '',
      timer_value: '',
      include_timer: '',
      user_time_value: '',
      first_question_id: '',
      display_question: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'icon-control-pause pause_btn',
      ValidToken: false,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      getComments: [],
      comment_data: '',
      flash_data: [],
      flash_form: 'col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      count_end_message: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      timer_display: 'card-block',
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      already_answered_status: '',
      display_loader: 'show_block',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
    };
  }
  // componentWillUnmount() {
  //   clearInterval(this.timer);
  // }
  //Function to change time every second and store in database
  tick() {
    if (this.state.count != 0) {
      var count_value = this.state.count;
      var insert_time = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        user_time_value: count_value,
      };
      FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
        if (resp.success) {
          // console.log('Timer Update Successfull');
        } else {
          // console.log('Fail Timer Update');
        }
      });
      this.setState({ count: this.state.count - 1 });
      this.setState({ timer_display: 'card-block' });
    } else {
      this.context.router.push({
        pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
          ':quiz_id',
          this.state.quiz_id,
        ).replace(':status_send', 'completed'),
      });
    }
    // if (this.state.timer_value == this.state.count) {
    //   console.log('another if');
    //   this.setState({ timer_display: 'card hide_block' });
    // }
    console.log('exit0-------');
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (parseInt(this.state.offset) == 0) {
      this.setState({ previ_block: 'card hide_block' });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      quiz_id: this.state.quiz_id,
    };
    //Api to fetch Quiz by quiz id
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuize', data).then(resp => {
      if (resp.success) {
        var retun_all_question = JSON.stringify(resp.singlequiz);
        var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
        let readings = JSON.parse(JSON.parse(retun_all_question)).readings;
        var question_id = [];
        var reading_id = [];
        for (var i = 0; i < resp.questions_count; i++) {
          question_id.push(all_questions[i]);
          reading_id.push(readings[i]);
        }
        var timer_value = resp.timer_value;

        var first_question_id = question_id[this.state.offset];
        var first_reading_type = reading_id[this.state.offset];
        var user_timer = resp.user_time_value;
        console.log('user_timer', resp.user_time_value);
        this.setState({
          user_time_value: user_timer,
          count: resp.user_time_value ? resp.user_time_value : parseInt(this.props.params.timer),
        });
        this.setState({
          all_question_id: question_id,
          question_length: question_id.length,
          timer_value: timer_value,
          include_timer: resp.include_timer,
          first_question_id: first_question_id,
          first_reading_type: first_reading_type,
          all_reading_type: reading_id,
        });

        if (question_id.length - 1 == this.state.offset) {
          this.setState({ next_block: 'card hide_block' });
        }

        var data = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: first_question_id,
          type: first_reading_type,
        };
        //Api to fetch question by question id
        FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
          if (resp.success) {
            var data_check = {
              token: this.state.token,
              idname: this.state.idname,
              quiz_id: this.state.quiz_id,
              question_id: first_question_id,
              type: first_reading_type,
            };
            /*Api to fetch question and check answered */
            FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(
              resp_inner => {
                this.setState({ already_answered_status: resp_inner.message });
              },
            );
            this.setState({ ValidToken: true });
            this.setState({ display_question: resp.questionsbyid });
            this.setState({ display_loader: 'hide_block' });
            var params = {
              token: this.state.token,
              question_id: first_question_id,
              idname: this.state.idname,
              type: first_reading_type,
            };
            /*Api to fetch Saved question */
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
              response => {
                if (response.success) {
                  this.setState({
                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  });
                  this.setState({
                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                  });
                  this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
                  this.setState({
                    save_text: `${language.LC().Question_Saved}`,
                  });
                }
              },
            );
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              quiz_id: this.state.quiz_id,
              question_id: first_question_id,
            };
            /*Api to fetch commented on question*/
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
              response => {
                if (response.success) {
                  var comments = '';
                  this.setState({ ValidToken: true });
                  if (response.comments.length > 0) {
                    comments = response.comments.map((items, index) => (
                      <li key={index}>
                        {response.user_id == items.uid ? (
                          <ul className='icon_list'>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._editComment.bind(this, items)}
                              >
                                <i className='fa fa-pencil' />
                              </a>
                            </li>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._deleteComment.bind(this, items)}
                              >
                                <i className='fa fa-close' />
                              </a>
                            </li>
                          </ul>
                        ) : (
                          <ul />
                        )}

                        <h4>
                          {language.LC().BY} {items.username},{' '}
                          {new Date(items.createdAt).toDateString()}
                        </h4>
                        <p>{items.comment}</p>
                      </li>
                    ));

                    this.setState({ comment_data: comments });
                  } else {
                    comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                    this.setState({ comment_data: comments });
                  }
                } else {
                  comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                  this.setState({ comment_data: comments });
                  this.setState({ ValidToken: false });
                }
                return response;
              },
            );
          } else {
            // console.log(resp.success + '------------failure');
          }
        });

        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: first_question_id,
          quiz_id: this.state.quiz_id,
        };
        /*Api to fetch flash card*/
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  //alert(items.id)
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-md-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-md-12 display_block' });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
      return resp;
    });
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  //Function to check Right Or Wrong Answered and displayed clicked box
  _getAnswer = (choice, e) => {
    this.setState({ clicked: true });
    this.setState({ choice: choice });
    if (choice === 'choice_a') {
      this.setState({ choice_a: 'answer_box clicked_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_b') {
      this.setState({ choice_b: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_c') {
      this.setState({ choice_c: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_d') {
      this.setState({ choice_d: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box ' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_e') {
      this.setState({ choice_e: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
    }
  };

  //Function to show Correct box and display right answer and store in database
  _getResult = (item, e) => {
    if (this.state.clicked) {
      clearInterval(this.timer);
      const chosen_answer = this.state.choice;
      var right_answer = 0;
      this.setState({ result_block: 'card show_block' });
      if (item.right_choice == this.state.choice) {
        right_answer = 1;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({ choice_b: 'answer_box success' });
        } else if (this.state.choice === 'choice_c') {
          this.setState({ choice_c: 'answer_box success' });
        } else if (this.state.choice === 'choice_d') {
          this.setState({ choice_d: 'answer_box success' });
        } else if (this.state.choice === 'choice_e') {
          this.setState({ choice_e: 'answer_box success' });
        }
        this.setState({ result: `${language.LC().CORRECT}` });
        this.setState({ text_color: 'card-header text_success' });
        this.setState({ result_block: 'card show_block' });
      } else {
        right_answer = 0;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box failure' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({ choice_b: 'answer_box failure' });
        } else if (this.state.choice === 'choice_c') {
          this.setState({ choice_c: 'answer_box failure' });
        } else if (this.state.choice === 'choice_d') {
          this.setState({ choice_d: 'answer_box failure' });
        } else if (this.state.choice === 'choice_e') {
          this.setState({ choice_e: 'answer_box failure' });
        }
        if (item.right_choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (item.right_choice === 'choice_b') {
          this.setState({ choice_b: 'answer_box success' });
        } else if (item.right_choice === 'choice_c') {
          this.setState({ choice_c: 'answer_box success' });
        } else if (item.right_choice === 'choice_d') {
          this.setState({ choice_d: 'answer_box success' });
        } else if (item.right_choice === 'choice_e') {
          this.setState({ choice_e: 'answer_box success' });
        }
        this.setState({ text_color: 'card-header text_failure' });
        this.setState({ result: `${language.LC().INCORRECT}` });
        this.setState({ result_block: 'card show_block' });
      }

      if (!this.state.validated) {
        //  console.log('quiz id  '+this.state.quiz_id+'---question_id---'+this.state.all_question_id[this.state.offset]+'-----right answer-----'+right_answer);
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          answer: right_answer,
          reading_id: item.reading_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_quizes/answerQuiz', data).then(resp => {
          if (resp.success) {
            var data = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: this.state.all_question_id[this.state.offset],
              right_answer: right_answer,
              time_done: 0,
            };
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(resp => {
              if (resp.success) {
              } else {
              }
            });
            this.setState({ ValidToken: true });
            this.setState({ validated: true });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        });
      }
    }
  };

  //Function to fetch Next question
  _getNext = () => {
    this.setState({ display_loader: 'show_block' });
    this.setState({ validated: false });
    this.setState({ clicked: false });
    this.setState({
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
    });
    this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
    this.setState({ bookmarkColor: '' });
    this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
    this.setState({ report_block: 'card hide_block' });
    document.getElementById('comment').value = '';
    // document.getElementById('ques_comment').value = '';

    var data = {
      idname: this.state.idname,
      token: this.state.token,
      quiz_id: this.state.quiz_id,
    };

    var insert_time = {
      token: this.state.token,
      idname: this.state.idname,
      quiz_id: this.state.quiz_id,
      user_time_value: this.state.count,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
      if (resp.success) {
        //console.log('Timer Update Successfull');
      } else {
        //console.log('Fail Timer Update');
      }
    });

    var index_id = this.state.offset + 1;
    if (index_id > 0) {
      this.setState({ previ_block: '' });
    }
    if (this.state.question_length - 1 == index_id) {
      this.setState({ next_block: 'card hide_block' });
    }
    this.setState({ offset: index_id });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.all_question_id[index_id],
      type: this.state.all_reading_type[index_id],
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
      const { questionsbyid } = resp;
      if (resp.success) {
        if (questionsbyid['gmat_reading.type'] === 'case_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':case', questionsbyid.case_id)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TWOPART_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':timer', this.state.count),
          });
        }

        var data_check = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          type: this.state.all_reading_type[this.state.offset],
        };
        this.setState({ display_loader: 'hide_block' });
        //console.log(data_check);
        FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(resp => {
          this.setState({ already_answered_status: resp.message });
        });
        this.setState({ choice_a: 'answer_box' });
        this.setState({ choice_b: 'answer_box' });
        this.setState({ choice_c: 'answer_box' });
        this.setState({ choice_d: 'answer_box' });
        this.setState({ choice_e: 'answer_box' });
        this.setState({ result_block: 'card hide_block' });
        this.setState({ display_question: resp.questionsbyid });

        var params = {
          token: this.state.token,
          question_id: this.state.all_question_id[this.state.offset],
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
          response => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              });
              this.setState({ save_text: `${language.LC().Question_Saved}` });
              this.setState({
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              });
              this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
            }
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  //alert(items.id)
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-md-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-md-12 display_block' });
            }
            return response;
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
    });
    clearInterval(this.timer);
    if (!this.state.timer_stop) {
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
  };
  //Function to fetch previous question
  _getPrevious = () => {
    this.setState({ display_loader: 'show_block' });
    this.setState({ validated: false });
    this.setState({ clicked: false });
    this.setState({
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
    });
    this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
    this.setState({ bookmarkColor: '' });
    this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
    this.setState({ report_block: 'card hide_block' });
    document.getElementById('comment').value = '';
    // document.getElementById('ques_comment').value = '';

    var insert_time = {
      token: this.state.token,
      idname: this.state.idname,
      quiz_id: this.state.quiz_id,
      user_time_value: this.state.count,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
      if (resp.success) {
        console.log('Timer Update Successfull');
      } else {
        console.log('Fail Timer Update');
      }
    });

    var index_id = this.state.offset - 1;
    if (this.state.question_length - 1 != index_id) {
      this.setState({ next_block: '' });
    }
    this.setState({ offset: index_id });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.all_question_id[index_id],
      type: this.state.all_reading_type[index_id],
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
      if (resp.success) {
        const { questionsbyid } = resp;
        if (questionsbyid['gmat_reading.type'] === 'case_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':case', questionsbyid.case_id)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TWOPART_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':timer', this.state.count),
          });
        }

        // this.context.router.push({
        //   pathname: AppRoutes.BEGIN_QUIZ.replace(
        //     ':quiz_id',
        //     this.state.quiz_id
        //   ).replace(':offset', parseInt(this.props.params.offset) - 1),

        //   //   `/gmat_beginquiz/${this.state.quiz_id}/${parseInt(
        //   //   this.props.params.offset
        //   // ) - 1}`,
        // });
        this.setState({ display_loader: 'hide_block' });
        var data_check = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          type: this.state.all_reading_type[this.state.offset],
        };
        FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(resp => {
          this.setState({ already_answered_status: resp.message });
        });
        this.setState({ choice_a: 'answer_box' });
        this.setState({ choice_b: 'answer_box' });
        this.setState({ choice_c: 'answer_box' });
        this.setState({ choice_d: 'answer_box' });
        this.setState({ choice_e: 'answer_box' });
        this.setState({ result_block: 'card hide_block' });
        this.setState({ display_question: resp.questionsbyid });

        var params = {
          token: this.state.token,
          question_id: this.state.all_question_id[this.state.offset],
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
          response => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              });
              this.setState({ save_text: `${language.LC().Question_Saved}` });
              this.setState({
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              });
              this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
            }
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-sm-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-sm-12 display_block' });
            }
            return response;
          },
        );
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
    });
    clearInterval(this.timer);
    if (!this.state.timer_stop) {
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
  };

  //Function to Display Question saved on button
  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          });
          this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
          this.setState({
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          });
          this.setState({ bookmarkColor: '' });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          });
          this.setState({ save_text: `${language.LC().Question_Saved}` });
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
          });
          this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  //Funcion to save new report question
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, successAlert: true });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  //Function to show Report box
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };
  //Function to toggle Comment box
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  //Function to toggle Flash box
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  //Function to Save flash Card And display new stored flash card
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value == '') {
      return;
    }
    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
      quiz_id: this.state.quiz_id,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/saveFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          quiz_id: this.state.quiz_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  //alert(items.id)
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-sm-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-sm-12 display_block' });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to Edit Flash card
  _editFlash = (item, e) => {
    this.setState({ flash_form: 'col-sm-12 display_block' });
    document.getElementById('flash_card').value = item.flash_card;
  };

  //Function to delete flash card
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/deleteFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({ flash_form: 'col-sm-12 display_block' });
        document.getElementById('flash_card').value = '';
        var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        this.setState({ flash_data: flash_cards });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to save comment And display new comment
  _saveComment = (item, e) => {
    if (document.getElementById('ques_comment').value == '') {
      return;
    }
    var comment = document.getElementById('ques_comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
      quiz_id: this.state.quiz_id,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/saveComment', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          quiz_id: this.state.quiz_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
      /// return resp;
    });
  };

  //Function to Edit particular comment
  _editComment = (item, e) => {
    document.getElementById('ques_comment').value = item.comment;
    this.setState({ comment_update: 'btn btn-primary active pointer_class' });
    this.setState({ comment_save: 'hide_block' });
    this.setState({ comment_update_id: item.id });
  };

  //Function to delete particular comment
  _deleteComment = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      comment: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/deleteComment', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.question_id,
          quiz_id: this.state.quiz_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to Update Comment
  _updateComment = (item, e) => {
    if (document.getElementById('ques_comment').value == '') {
      return;
    }
    var comment = document.getElementById('ques_comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      comment_id: this.state.comment_update_id,
      comment: comment,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/updateComment', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        this.setState({ comment_update: 'hide_block' });
        this.setState({
          comment_save: 'btn btn-primary active pointer_class',
        });
        this.setState({ comment_update_id: '' });
        document.getElementById('ques_comment').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          quiz_id: this.state.quiz_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              //this.setState({getComments : resp.comments});
              if (response.comments.length > 0) {
                comments = response.comments.map((items, index) => (
                  //alert(items.id)
                  <li key={index}>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  /*Function to start or stop timer*/
  _timer_funct = (item, e) => {
    // this.setState({timer_stop:!this.state.timer_stop});
    if (this.state.timer_stop) {
      this.setState({ timer_stop: false });
      /*this.setState({timer_tag:'Stop'});   */
      this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
    } else {
      this.setState({ timer_stop: true });
      this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
      /*    this.setState({timer_tag:'Start'}); */
      clearInterval(this.timer);
    }
  };

  //Function to redirect page to readings beforestart
  _getSummary = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(
        ':status_send',
        'abondon',
      ),

      //   `/gmat_beforestart/${this.state.quiz_id}/${'abondon'}`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   quiz_id: this.state.quiz_id,
      //   status_send: 'abondon',
      // },
    });
  };

  render() {
    let questions = this.state.display_question;
    const choice_a = 'choice_a';
    const choice_b = 'choice_b';
    const choice_c = 'choice_c';
    const choice_d = 'choice_d';
    const choice_e = 'choice_e';
    let data = '';
    console.log('this.state.count', this.state.count);
    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }

    if (this.state.question_length >= parseInt(this.state.offset) - 1) {
      data = (
        <div>
          <div className='card margin_bottom_40'>
            <div className='card-header'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                className='margin_right_20'
                width='30'
                alt=''
              />
              {language.LC().Q} {parseInt(this.state.offset) + 1}{' '}
              <div className='float-right text-right'>
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <div className='row'>
                    <div className='col-sm-12'>
                      {renderHTMLContent(
                        questions.question,
                        "div",
                        "margin_bottom_40 view_questionhtml bg_blue",
                        { contentEditable: 'false' }
                      )}
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_a'
                      onClick={this._getAnswer.bind(this, choice_a)}
                    >
                      <div className={this.state.choice_a}>
                        <div className='answer_count'>{language.LC().A}</div>

                        <p className='ans_box_text'>
                          {renderHTMLContent(
                            questions.choice_a,
                            "span",
                            "",
                            { contentEditable: "false" }
                          )}
                        </p>
                      </div>
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_b'
                      onClick={this._getAnswer.bind(this, choice_b)}
                    >
                      <div className={this.state.choice_b}>
                        <div className='answer_count'>{language.LC().B}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(
                            questions.choice_b,
                            "span",
                            "",
                            { contentEditable: "false" }
                          )}
                        </p>
                      </div>
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_c'
                      onClick={this._getAnswer.bind(this, choice_c)}
                    >
                      <div className={this.state.choice_c}>
                        <div className='answer_count'>{language.LC().C}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(
                            questions.choice_c,
                            "span",
                            "",
                            { contentEditable: "false" }
                          )}
                        </p>
                      </div>
                    </div>
                    <div
                      className='col-sm-12'
                      id='choice_d'
                      onClick={this._getAnswer.bind(this, choice_d)}
                    >
                      <div className={this.state.choice_d}>
                        <div className='answer_count'>{language.LC().D}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(
                            questions.choice_d,
                            "span",
                            "",
                            { contentEditable: "false" }
                          )}

                        </p>
                      </div>
                    </div>
                    <div
                      className='col-sm-12'
                      id='choice_e'
                      onClick={this._getAnswer.bind(this, choice_e)}
                    >
                      <div className={this.state.choice_e}>
                        <div className='answer_count'>{language.LC().E}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(
                            questions.choice_e,
                            "span",
                            "",
                            { contentEditable: "false" }
                          )}
                        </p>
                      </div>
                    </div>

                    <Col md={12} className='mt-2'>
                      <Row className='align-items-center'>
                        <ValidateSaveReportIcon
                          isQue={true}
                          _getResult={this._getResult}
                          _saveQuestion={this._saveQuestion}
                          _displayReportForm={this._displayReportForm}
                          all_questions={questions}
                          save_text={this.state.save_text}
                          bookmarkCSS={this.state.bookmarkCSS}
                          bookmarkColor={this.state.bookmarkColor}
                        />
                      </Row>
                    </Col>
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='timer_outer'>
                    <i className='fa fa-clock-o' />
                    <span className='timer_box'>{display_time}</span>
                  </div>
                  <span className={'quiz_timer_btn ' + this.state.timer_display}>
                    <button
                      type='button'
                      className={this.state.timerstopbtn}
                      onClick={this._timer_funct.bind(this, questions)}
                    >
                      {/*this.state.timer_tag*/}
                      {/*<img width="27" src={App_data.frontend_url+"/img/quizzes/stop_icon.svg"} className="" alt=""></img>*/}
                    </button>
                  </span>
                  <p className='text-danger'>
                    {renderHTMLContent(
                      this.state.count_end_message,
                      "div",
                      "",
                      { contentEditable: 'false' }
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={`${this.state.result_block} font-lusitana font-16px`}>
            <div className={this.state.text_color}>{this.state.result}</div>
            <div className='card-block'>
              {renderHTMLContent(
                questions.answer,
                "div",
                "",
                { contentEditable: 'false' }
              )}
            </div>
          </div>

          <div className={this.state.report_block}>
            <div className='card-header'>
              {language.LC().REPORT}
              {/* <TooltipItem
                      key="1"
                      id="1"
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    /> */}
            </div>
            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-sm-12 margin_bottom_10'>
                    <textarea
                      id='comment'
                      name='comment'
                      rows='6'
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class'
                      onClick={this._reportQuestion.bind(this, questions)}
                    >
                      {language.LC().REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={this._hideReportForm.bind(this, questions)}
                    >
                      {language.LC().CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={this.onClose}
                    >
                      {' '}
                      {language.LC().CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* <div className='row'>
            <div className='col-md-6'>
              <div className='card'>
                <div
                  className='card-header pointer_class'
                  onClick={this._getToggleComment.bind(this, questions)}
                >
                  {language.LC().COMMENT}
                  <TooltipItem
                    key='0'
                    id='0'
                    content={this.state.tooltips[0].placement}
                    place_tip={this.state.tooltips[0].text_align}
                  />
                  <div className='float-right text-right'>
                    <img
                      src={App_data.frontend_url + '/img/arrow_down_ico.png'}
                      alt=''
                    />
                  </div>
                </div>
                <div style={{ display: 'none' }} ref='comment_toggle_div'>
                  <div className='card-block'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <ul className='comment_list_wrapper'>
                          {this.state.comment_data}
                        </ul>
                      </div>
                      <div className='col-md-12'>
                        <form>
                          <textarea
                            id='ques_comment'
                            name='ques_comment'
                            rows='6'
                            className='form-control margin_bottom_10'
                            placeholder='Comment'
                          />
                          <button
                            type='button'
                            className={
                              'margin_bottom_20 ' + this.state.comment_save
                            }
                            onClick={this._saveComment.bind(this, questions)}
                          >
                            {language.LC().COMMENT}
                          </button>
                          <button
                            type='button'
                            className={
                              'margin_bottom_20 ' + this.state.comment_update
                            }
                            onClick={this._updateComment.bind(this, questions)}
                          >
                            {' '}
                            {language.LC().UPDATE_COMMENT}{' '}
                          </button>
                          <p>
                            *
                            {
                              language.LC()
                                .YOU_CAN_USE_THE_COMMENT_SECTION_TO_ASK_A_QUESTION_OR_TO_SHOW_HOW_YOU_SOLVED_THE_PROBLEM_Dont_hesitate_to_share_your_thoughts_it_could_help_other_candidates
                            }{' '}
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='card'>
                <div
                  className='card-header pointer_class'
                  onClick={this._getToggleFlash.bind(this, questions)}
                >
                  {language.LC().FLASHCARD}
                  <TooltipItem
                    key='2'
                    id='2'
                    content={this.state.tooltips[2].placement}
                    place_tip={this.state.tooltips[2].text_align}
                  />
                  <div className='float-right text-right'>
                    <img
                      src={App_data.frontend_url + '/img/arrow_down_ico.png'}
                      alt=''
                    />
                  </div>
                </div>
                <div style={{ display: 'none' }} ref='flash_toggle_div'>
                  <div className='card-block'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <ul className='comment_list_wrapper'>
                          {this.state.flash_data}
                        </ul>
                      </div>
                      <div className={this.state.flash_form}>
                        <form>
                          <textarea
                            id='flash_card'
                            name='flash_card'
                            rows='6'
                            className='form-control margin_bottom_10'
                            placeholder='Your flash card here'
                          />
                          <button
                            type='button'
                            className='margin_bottom_20 btn btn-primary active pointer_class'
                            onClick={this._saveFlashCard.bind(this, questions)}
                          >
                            {language.LC().CREATE}
                          </button>
                          <p>
                            *
                            {
                              language.LC()
                                .FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study
                            }
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      );
    } else {
      data = '<div>Data Not Found</div>';
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-sm-8 margin_bottom_20'>
              <h1 className='section_head'>
                {language.LC().QUIZ_ID} : {this.state.quiz_id}
              </h1>
              <h6 className='text-danger'>{this.state.already_answered_status}</h6>
            </div>
            <div className='col-sm-4 margin_bottom_20 text-sm-right'>
              <button className='btn btn-primary pointer_class' onClick={this._getSummary}>
                {' '}
                {language.LC().BACK_TO_SUMMARY}{' '}
              </button>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-md-12 margin_bottom_20'>{data}</div>
          </div>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}
class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default Beginquiz;



// WEBPACK FOOTER //
// ./src/views/GMAT/Quizzes/Beginquiz.js